/**
 * As telas do painel. Cada uma é um caminho próprio, não um parâmetro:
 * o link diz a tela, e o voltar do navegador troca de tela em vez de sair do painel.
 */
export class MonitorsView {
  static readonly JOBS = new MonitorsView('/jobs', 'Jobs');
  static readonly COSTS = new MonitorsView('/costs', 'Custos');
  static readonly RECIPIENTS = new MonitorsView('/envios', 'Lista de envios');
  static readonly REPORTS = new MonitorsView('/relatorios', 'Relatórios');

  private static readonly BY_PATH: Record<string, MonitorsView> = {
    '/jobs': MonitorsView.JOBS,
    '/costs': MonitorsView.COSTS,
    '/envios': MonitorsView.RECIPIENTS,
    '/relatorios': MonitorsView.REPORTS,
  };

  private constructor(
    readonly path: string,
    readonly label: string,
  ) {}

  static all(): MonitorsView[] {
    return [MonitorsView.JOBS, MonitorsView.COSTS, MonitorsView.RECIPIENTS, MonitorsView.REPORTS];
  }

  /**
   * Caminho desconhecido — inclusive a raiz — cai em Jobs, a tela de abertura.
   *
   * O casamento é por PREFIXO porque a tela de custos tem caminhos abaixo dela
   * (`/costs/cliente/<id>`): com igualdade exata, abrir o detalhe pelo link
   * derrubava o painel inteiro em Jobs.
   */
  static fromPath(path: string): MonitorsView {
    const clean = path.replace(/\/+$/, '');
    const exact = MonitorsView.BY_PATH[clean];
    if (exact) return exact;

    return (
      MonitorsView.all().find((view) => clean.startsWith(`${view.path}/`)) ?? MonitorsView.JOBS
    );
  }

  is(other: MonitorsView): boolean {
    return this.path === other.path;
  }

  get showsCosts(): boolean {
    return this.is(MonitorsView.COSTS);
  }

  get showsRecipients(): boolean {
    return this.is(MonitorsView.RECIPIENTS);
  }

  get showsReports(): boolean {
    return this.is(MonitorsView.REPORTS);
  }
}
